module.exports = __webpack_public_path__ + "img/linda.ee9f976a.jpg";